'use strict';var ENVIRONMENT=require('../internals/environment');module.exports=ENVIRONMENT==='NODE';